import {
  LOW_TEMP,
  HIGH_TEMP,
  LOW_PULSE,
  HIGH_PULSE,
  LOW_RESPIRATION,
  HIGH_RESPIRATION,
  LOW_OXYGEN,
  HIGH_OXYGEN,
  LOW_SYSTOLIC,
  HIGH_SYSTOLIC,
  LOW_DIASTOLIC,
  HIGH_DIASTOLIC
} from '../store/modules/form-types'
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())

    return {
      answersById: [],
      checkboxDisabledState: [],
      showFailedScreeningModal: false,
      failureModalDescription: '',
      failureStopDescription: '',
      formAnswers: {},
      max: today,
      dateFormatOptions: {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      },
      questionAnswersAndStatesSetup: false
    }
  },
  mounted () {
    this.initMixin()
  },
  computed: {
    ...mapGetters([
      'applicationReady',
      'selectedUser'
    ]),
    ...mapGetters({
      questions: 'forms/questions',
      currentPage: 'forms/currentPage',
      numberOfPages: 'forms/numberOfPages',
      currentQuestionnaire: 'forms/currentQuestionnaire',
      selectedQuestionnaireId: 'forms/selectedQuestionnaireId',
      formSubmitted: 'forms/formSubmitted',
      failedScreening: 'forms/failedScreening',
      failureDescription: 'forms/failureDescription'
    }),
    currentQuestion () {
      if (this.questions !== undefined) {
        return this.questions.find(question => question.page === this.currentPage)
      }
      return {}
    },
    currentQuestionId () {
      return this.currentQuestion.id
    },
    selectedUserName () {
      return (this.selectedUser.itemNameParts.length >= 1 ? this.selectedUser.itemNameParts[0] : this.selectedUser.itemName)
    },
    canGoBack () {
      if (this.questions !== undefined) {
        return this.currentPage === 1 || this.questions.length === 1
      }
      return false
    },
    canGoForward () {
      return this.currentPage >= this.numberOfPages
    },
    questionClasses () {
      const classes = []
      classes.push('question')
      if (this.currentQuestion !== undefined && this.currentQuestion.subQuestion !== undefined && !this.currentQuestion.subQuestion) {
        classes.push('question-margin-bottom')
      }
      return classes
    },
    canSubmitForm () {
      return this.canGoForward
    },
    lowTemp () {
      return LOW_TEMP
    },
    highTemp () {
      return HIGH_TEMP
    },
    lowPulse () {
      return LOW_PULSE
    },
    highPulse () {
      return HIGH_PULSE
    },
    lowRespiration () {
      return LOW_RESPIRATION
    },
    highRespiration () {
      return HIGH_RESPIRATION
    },
    lowOxygen () {
      return LOW_OXYGEN
    },
    highOxygen () {
      return HIGH_OXYGEN
    },
    lowSystolic () {
      return LOW_SYSTOLIC
    },
    highSystolic () {
      return HIGH_SYSTOLIC
    },
    lowDiastolic () {
      return LOW_DIASTOLIC
    },
    highDiastolic () {
      return HIGH_DIASTOLIC
    }
  },
  watch: {
    formAnswers: {
      handler: function (newAnswers) {
        if (newAnswers !== undefined) {
          for (const [key, value] of Object.entries(newAnswers)) {
            const question = this.findQuestionBySection(key)
            if (question !== undefined) {
              this.answersById[question.id] = value
            }
          }
        }
      },
      deep: true
    },
    currentPage () {
      if (window.scrollY > 0) {
        window.scrollTo(0, 0)
      }
    }
  },
  methods: {
    ...mapActions([
      'setPageAlertInformation',
      'clearPageAlertInformation'
    ]),
    ...mapActions({
      setFormReady: 'forms/setFormReady',
      setCurrentPage: 'forms/setCurrentPage',
      nextPage: 'forms/nextPage',
      previousPage: 'forms/previousPage',
      logout: 'authentication/logout',
      setFormSubmitted: 'forms/setFormSubmitted',
      setFailedScreening: 'forms/setFailedScreening',
      addFormResults: 'forms/addFormResults',
      setFailureDescription: 'forms/setFailureDescription',
      isMultiStep: 'forms/isMultiStep',
      isSingleStep: 'forms/isSingleStep',
      submitVaccineData: 'forms/submitVaccineData'
    }),
    async initMixin () {
      await this.setupQuestionAnswersAndStates()
    },
    setupQuestionAnswersAndStates () {
      if (this.questions !== undefined && this.questions.length > 0) {
        this.questions.forEach(question => {
          if (question.type === 'checkbox' || question.type === 'select') {
            this.answersById[question.id] = []

            if (question.type === 'checkbox') {
              this.checkboxDisabledState[question.id] = []
              question.values.forEach(value => {
                this.checkboxDisabledState[question.id][value.id] = false
              })
            }
          } else {
            this.answersById[question.id] = ''
          }
        })
        this.questionAnswersAndStatesSetup = true
      }
    },
    isNoOption (question) {
      return question.answer_text.toLowerCase() === 'no'
    },
    findQuestionBySection (section) {
      if (this.questions !== undefined) {
        return this.questions.find(question => question.section === section)
      }
      return {}
    },
    questionHasSection (section) {
      if (this.questions !== undefined) {
        return this.questions.findIndex(question => question.section === section) >= 0
      }
      return {}
    },
    findValueByName (name, values) {
      return values.find(value => value.answer_text.toLowerCase() === name)
    },
    setCurrentDateAndTime (type = 'exit') {
      const date = new Date()
      const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: 'numeric', hour12: false })
      const [{ value: month },, { value: day },, { value: year },, { value: hour },, { value: minute }] = dateTimeFormat.formatToParts(date)

      if (type === 'exit') {
        this.formAnswers.enterDateOfExit = year + '-' + month + '-' + day
        this.formAnswers.enterTimeOfExit = hour + ':' + minute + ':00'
      }

      if (type === 'entry') {
        this.formAnswers.enterDateOfEntry = year + '-' + month + '-' + day
        this.formAnswers.enterTimeOfEntry = hour + ':' + minute + ':00'
      }
      if (type === 'testing') {
        this.formAnswers.enterDateOfTest = year + '-' + month + '-' + day
        this.formAnswers.enterTimeOfTest = hour + ':' + minute + ':00'
      }
      if (type === 'midshift') {
        this.formAnswers.enterDateOfMidshift = year + '-' + month + '-' + day
        this.formAnswers.enterTimeOfMidshift = hour + ':' + minute + ':00'
      }

      if (type === 'healthcheck') {
        this.formAnswers.enterDateOfHealthCheck = year + '-' + month + '-' + day
        this.formAnswers.enterTimeOfHealthCheck = hour + ':' + minute + ':00'
      }
    },
    questionCheckboxClasses (question) {
      const classes = []
      classes.push('question-checkbox')

      if (question.answer_text.toLowerCase() === 'no') {
        classes.push('no')
      }
      return classes
    },
    setDisabledStateForMoreThanTwoCheckboxes (newAnswers, oldAnswers) {
      if (newAnswers !== undefined) {
        const values = this.currentQuestion.values
        const noValue = values.find(value => value.answer_text.toLowerCase() === 'no')
        const noChecked = newAnswers[noValue.id]

        if (noChecked) {
          /**
             * no is checked, disable all others
             */
          values.forEach(value => {
            if (value.id !== noValue.id) {
              this.checkboxDisabledState[this.currentQuestionId][value.id] = true
            }
          })
        } else {
          let disableNo = false
          newAnswers.forEach((isChecked, key) => {
            /**
               * See if anything other than "no" is checked.
               * If so, disable "no".
               */
            if (isChecked && key !== noValue.id) {
              disableNo = true
            }
            this.checkboxDisabledState[this.currentQuestionId][key] = false
          })

          /**
             * Unlock everything but "no"
             */
          values.forEach(value => {
            if (value.id !== noValue.id) {
              this.checkboxDisabledState[this.currentQuestionId][value.id] = false
            }
          })

          /**
             * Finally, set "no".
             */
          this.checkboxDisabledState[this.currentQuestionId][noValue.id] = disableNo
        }
      }
    },
    replaceText (text, lookFor, replaceWith) {
      lookFor.forEach((nugget, index) => {
        let newText = replaceWith[index]
        if (newText === 'firstname') {
          newText = this.selectedUserName
        }
        text = text.replace(nugget, newText)
      })
      return text
    }
  }
}
